import React, { ReactElement, useEffect, useState } from 'react';
import { useDeleteEntite, useGetQuery, useUpdateEntite } from '../../../Utils/api';
import { Badge, Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { Entente } from '../../../../../common/src/entities';
import { CellProps } from 'react-table';
import { Colonne } from '../Utils/TypesTableSimple';
import { BiPlus } from 'react-icons/bi';
import { LinkContainer } from 'react-router-bootstrap';
import EnteteDePage from '../Utils/EnteteDePage';
import TableSimple from '../Utils/TableSimple';
import { useNavigate } from 'react-router-dom';
import PopoverSimple from '../../Common/PopoverSimple';
import DynamicTableContact from './Tables/DynamicTableContact';
import { default as DynamicTableClient } from './Tables/DynamicTableClient';
import { default as DynamicTableCSS } from './Tables/DynamicTableCSS';
import FiltreEntente from './FiltreEntente';
import DynamicTableDetails from './Tables/DynamicTableDetails';
import DynamicTableActivites from './Tables/DynamicTableActivites';

//TODO voir croquis de la liste des ententes dans le document Word
export default function Ententes(): ReactElement {
    const navigate = useNavigate();
    const [supprimerEntenteQuery] = useDeleteEntite(Entente);
    const [updateEntente] = useUpdateEntite(Entente);
    const bsAlert = useAlertDialog();
    const [filters, setFilters] = useState({});
    const queryKey = ['ententes/dashboard', filters];

    const listEntente = useGetQuery<Entente[]>(queryKey);

    const handleFilter = (newFilters) => {
        setFilters(newFilters);
    };

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const handleToggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    useEffect(() => {
        document.title = 'Ententes - Dashboard';
    }, []);

    const colonnes: Colonne<Entente>[] = [
        {
            Header: '# entente',
            accessor: 'id',
            sortType: (rowA, rowB) => {
                return rowA.original.name.localeCompare(rowB.original.name, 'fr-CA');
            },
        },

        {
            Header: 'Nom',
            Cell: function CelluleDetails({ row }: CellProps<Entente>) {
                const title2 = "Informations supplémentaires à propos de l'entente";
                return (
                    <>
                        <PopoverSimple
                            inList
                            texte={
                                <>
                                    <DynamicTableDetails title={title2} data={row.original} />
                                </>
                            }
                        >
                            <u>{row.original.name as any}</u>
                        </PopoverSimple>
                    </>
                );
            },
        },

        {
            Header: 'Statut',
            Cell: function CelluleSuivi({ row }: CellProps<Entente>) {
                const variant = row.original.statut === 'Annulé' ? 'danger' : 'warning';
                const style = { fontSize: '16px' };
                return row.original.statut ? (
                    <Badge variant={variant}>
                        <span style={style}>{row.original.statut}</span>
                    </Badge>
                ) : (
                    <span>N/A</span>
                );
            },
        },
        {
            Header: 'Contact',
            Cell: function CelluleContacts({ row }: CellProps<Entente>) {
                const contacts = row.original.contacts || row.original.client.contacts || [];
                const title2 = 'Informations supplémentaires à propos du contact ' + contacts[0]?.contact.name;
                return contacts.length > 0 ? (
                    <>
                        <PopoverSimple
                            inList
                            texte={
                                <>
                                    <DynamicTableContact title={title2} data={contacts[0].contact} />
                                </>
                            }
                        >
                            <u>{contacts[0].contact.name as any}</u>
                        </PopoverSimple>
                    </>
                ) : (
                    <span>0</span>
                );
            },
        },

        {
            Header: 'Client',
            Cell: function CelluleContacts({ row }: CellProps<Entente>) {
                const title2 = 'Informations supplémentaires à propos du client ' + row.original?.client?.name;
                return row.original.client ? (
                    <>
                        <PopoverSimple
                            inList
                            texte={
                                <>
                                    <DynamicTableClient title={title2} data={row.original?.client} />
                                </>
                            }
                        >
                            <u>{row.original.client?.name as any}</u>
                        </PopoverSimple>
                    </>
                ) : (
                    <span>0</span>
                );
            },
        },

        {
            Header: 'Activités',
            Cell: function CelluleContacts({ row }: CellProps<Entente>) {
                const title2 = 'Informations supplémentaires à propos des activités';
                return row.original.activiteEntentes.length > 0 ? (
                    <>
                        <PopoverSimple
                            inList
                            texte={
                                <>
                                    <DynamicTableActivites title={title2} data={row.original.activiteEntentes} />
                                </>
                            }
                        >
                            <u>{row.original.activiteEntentes[0]?.activite.name as any}</u>
                        </PopoverSimple>
                    </>
                ) : (
                    <span>0</span>
                );
            },
        },

        {
            Header: 'CSS',
            Cell: function CelluleContacts({ row }: CellProps<Entente>) {
                const title2 =
                    'Informations supplémentaires à propos du CSS ' +
                    row.original?.client?.centre_service_scolaire?.name;
                return row.original?.client?.centre_service_scolaire ? (
                    <>
                        <PopoverSimple
                            inList
                            texte={
                                <>
                                    <DynamicTableCSS
                                        title={title2}
                                        data={row.original?.client?.centre_service_scolaire}
                                    />
                                </>
                            }
                        >
                            <u>{row.original?.client?.centre_service_scolaire.abbr as any}</u>
                        </PopoverSimple>
                    </>
                ) : (
                    <span>0</span>
                );
            },
        },

        {
            Header: '# Participant',
            accessor: (row) => {
                return 0;
            },
        },

        {
            Header: 'Sortie',
            accessor: (row) => {
                return row.est_sortie ? 'Oui' : 'Non';
            },
        },

        {
            Header: 'Lieu',
            accessor: (row) => {
                if (row.lieu) return row.lieu.adresse;
                return 'N/A';
            },
        },

        {
            Header: 'Date activité',
            accessor: (row) => {
                // Convertissez la chaîne de caractères en objet Date
                if (row.date_activite) {
                    const maDate = new Date(row.date_activite);
                    return `${maDate.getDate()}/${maDate.getMonth() + 1}/${maDate.getFullYear()}`;
                } else {
                    return 'N/A';
                }
            },
        },
    ];

    const deleteEntente = async (p: Entente) => {
        if (window.confirm('Etes-vous sur de vouloir supprimer cette entente?')) {
            try {
                await supprimerEntenteQuery(p.id);
            } catch (error) {
                const { response, message } = error as any;
                if (response?.status === 409) {
                    bsAlert("D'autres entités dépendent de cette entente, impossible de la supprimer", 'warning');
                } else {
                    bsAlert(`Erreur dans la suppression du fournisseur: ${message}`, 'danger');
                }
            }
        }
    };

    const annulerEntente = async (p: Entente) => {
        if (window.confirm('Êtes-vous sûr de vouloir annuler cette entente?')) {
            try {
                await updateEntente({ id: p.id, statut: 'Annulée' });
                bsAlert('Entente annulée avec succès', 'success');
            } catch (error) {
                const { response, message } = error as any;
                if (response?.status === 409) {
                    bsAlert("D'autres entités dépendent de cette entente, impossible de l'annuler", 'warning');
                } else {
                    bsAlert(`Erreur dans l'annulation de l'entente: ${message}`, 'danger');
                }
            }
        }
    };

    const toggleStatutEntente = async (p: Entente) => {
        const nouveauStatut = p.statut === 'Annulé' ? 'Soumission' : 'Annulé';
        if (
            window.confirm(
                `Êtes-vous sûr de vouloir ${nouveauStatut === 'Annulé' ? 'annuler' : 'activer'} cette entente?`,
            )
        ) {
            try {
                await updateEntente({ id: p.id, statut: nouveauStatut });
                bsAlert(`Entente ${nouveauStatut === 'Annulé' ? 'annulée' : 'activée'} avec succès`, 'success');
            } catch (error) {
                const { response, message } = error as any;
                if (response?.status === 409) {
                    bsAlert(
                        `D'autres entités dépendent de cette entente, impossible de la ${
                            nouveauStatut === 'Annulé' ? 'annuler' : 'activer'
                        }`,
                        'warning',
                    );
                } else {
                    bsAlert(
                        `Erreur dans la ${
                            nouveauStatut === 'Annulé' ? 'annulation' : 'activation'
                        } de l'entente: ${message}`,
                        'danger',
                    );
                }
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Ententes" cacherBoutonRetour />
                </Col>
                <Col xs="auto">
                    <ButtonGroup>
                        <LinkContainer to="new">
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter une entente
                            </Button>
                        </LinkContainer>
                    </ButtonGroup>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col>
                    <FiltreEntente onFilter={handleFilter} />
                </Col>
            </Row>

            <TableSimple
                colonnes={colonnes}
                resultat={listEntente}
                lien="id"
                hover
                affichageMenu={(entente: Entente) => (
                    <>
                        <Dropdown.Item onClick={() => navigate(String(entente.id) + '/menu')}>Menu</Dropdown.Item>
                        <Dropdown.Item onClick={() => navigate(String(entente.id))}>Modifier</Dropdown.Item>
                        <Dropdown.Item onClick={() => navigate(String(entente.id) + '/menu?emailModal=true')}>
                            Envoyer un courriel
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => {}}>Calendrier</Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => toggleStatutEntente(entente)}
                            className={entente.statut === 'Annulé' ? '' : 'text-danger'}
                        >
                            {entente.statut === 'Annulé' ? 'Activer' : 'Annuler'}
                        </Dropdown.Item>
                    </>
                )}
            />
        </>
    );
}
